<template>
  <div style="margin: 10px; height: 600px">
    <v-form
      direction="horizontal"
      :model="options"
      :rules="rules"
      ref="ruleForm"
    >
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button
            type="success"
            icon="save"
            @click.prevent="submitForm('ruleForm')"
            >保存</v-button
          >
        </v-affix>
      </div>
       <v-form-item
        label="部门编码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        prop="bmbm"
        has-feedback
        required
      >
        <v-input v-model="options.bmbm" placeholder="部门编码"></v-input>
      </v-form-item>

      <v-form-item
        label="部门名称"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        prop="bmmc"
        has-feedback
        required
      >
        <v-input v-model="options.bmmc" placeholder="部门名称"></v-input>
      </v-form-item>

      <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="options.xybz"></v-switch>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {
  id:"",
  bmbm: "",
  bmmc: "",
  xybz: true,
};
export default {
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      options,
      rules: {
        bmbm: [{
          required: true,
          message: '请输入部门编码'
        }],
          bmmc: [{
          required: true,
          message: '请输入部门名称'
        }]
      },
    };
  },
  created() {
     
    if(this.$route.query.id!= undefined && this.$route.query.id!='' ){
      this.init()
    }
  },
  methods: {
    //初始话修改界面
    init(){
      this.$axios
        .get("api/system/qxgl/get-sysbm-first?id=" + this.$route.query.id)
        .then((res) => {
          this.options = res.data;
          if (res.data.xybz == 1) {
            this.options.xybz = true;
          } else {
            this.options.xybz = false;
          }
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 
          this.options.id = this.$route.query.id;
          this.$axios
            .post("api/system/qxgl/set-sysbm-first", this.options)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message["success"](res.data.message);
                xadmin.close();
              
              } else {
                this.$message["error"](res.data.message);
              }
            });
        }
      });
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/yhgl/sysbmadd.vue